var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"compass"},[_c('img',{style:(`transform: rotate(${_vm.rotate}deg)`),attrs:{"src":require("@/assets/icon-compass.svg"),"height":"auto","width":"64","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }